import { Provider } from '@angular/core';
import { ArrivalBoardDataSource } from './services/arrival-board-data-source';
import { HttpArrivalBoardDataSource } from './services/http-arrival-board-data-source.service';
import { ArrivalBoardConfigService } from './services/arrival-board-config.service';
import { HttpArrivalBoardConfigService } from './services/http-arrival-board-config.service';

/**
 * DI wiring for the ArrivalBoard feature. Bind these on the board/editor routes (or in
 * app config). Both seams now point at the backend; the mock datasource and the
 * localStorage config store are kept as unit-test doubles and as a dev harness, and can be
 * put back by changing only the `useClass` targets here — no page or component changes.
 *
 * Note the mock datasource additionally implements the simulator methods the kiosk page's
 * dev control panel is duck-typed on, so swapping it back also brings that panel back.
 */
export const ARRIVAL_BOARD_PROVIDERS: Provider[] = [
    { provide: ArrivalBoardDataSource, useClass: HttpArrivalBoardDataSource },
    { provide: ArrivalBoardConfigService, useClass: HttpArrivalBoardConfigService },
];
